import { ModalDialog } from '../ModalDialog/ModalDialog'
import { Button } from 'components/Button'
import * as CSS from 'csstype'

import Styles from './LayerInaccessibleModal.module.scss'

import { LayerInaccessibleModalProps } from './Types'

const LayerInaccessibleModal = ({ isOpen, onClose, layer }: LayerInaccessibleModalProps) => {
  const style: CSS.Properties = {
    ['--layer-color' as any]: layer?.color,
  }

  return (
    <ModalDialog isOpen={isOpen} title="" onClose={onClose} className={Styles.modal}>
      <h3 className={Styles.title}>
        <span className={Styles.layerName} style={style}>
          {layer?.name || 'This layer'}
        </span>{' '}
        is no longer accessible
      </h3>
      <p className={Styles.description}>This layer has been deleted or made private by another editor.</p>
      <Button size="lg" onPress={onClose} className={Styles.button}>
        Go to Main
      </Button>
    </ModalDialog>
  )
}

export { LayerInaccessibleModal }
